import { createSlice } from '@reduxjs/toolkit'

const loadUser = () => {
  try {
    const stored = localStorage.getItem('hdl_user');
    return stored ? JSON.parse(stored) : null;
  } catch { return null; }
};

const initialState = {
  user: loadUser(),
  accessToken: localStorage.getItem('hdl_token') || null,
  email: '',
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem('hdl_user', JSON.stringify(action.payload));
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      localStorage.setItem('hdl_token', action.payload);
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setLogOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.email = '';
      localStorage.removeItem('hdl_user');
      localStorage.removeItem('hdl_token');
    },
  },
})

export const { setUser, setAccessToken, setEmail, setLogOut } = authSlice.actions
export default authSlice.reducer
